"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trimPhoneNumber = exports.phoneValidator = void 0;
var _libphonenumberJs = _interopRequireDefault(require("libphonenumber-js"));
var _lodash = require("lodash");
var _phoneNumber = require("./phone-number.utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var debounceDelay = 300;
var countryCode = '1';
var phoneValidator = function phoneValidator() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$delay = _ref.delay,
    delay = _ref$delay === void 0 ? debounceDelay : _ref$delay,
    _ref$countryCode = _ref.countryCode,
    countryCode = _ref$countryCode === void 0 ? _phoneNumber.PhoneNumberUtils.getPhoneNumberCountryCode() : _ref$countryCode,
    _ref$validateCountryC = _ref.validateCountryCode,
    validateCountryCode = _ref$validateCountryC === void 0 ? true : _ref$validateCountryC;
  return (0, _lodash.debounce)(function (rule, value, callback) {
    if (!value) {
      callback();
      return;
    }
    var phoneNumber = (0, _libphonenumberJs.default)(value, countryCode);
    var validPhoneNumber = false;
    var includesCountryCode = validateCountryCode && hasCountryCodePrefix(phoneNumber);
    if (!(0, _lodash.isEmpty)(phoneNumber) && !includesCountryCode) {
      validPhoneNumber = phoneNumber.isValid();
    }
    var validationErrorMessage = includesCountryCode ? 'Phone number starting with country code is invalid' : 'Phone number is invalid';
    callback(validPhoneNumber ? undefined : validationErrorMessage);
  }, delay);
};
exports.phoneValidator = phoneValidator;
var hasCountryCodePrefix = function hasCountryCodePrefix(phoneNumber) {
  if (phoneNumber !== null && phoneNumber !== void 0 && phoneNumber.nationalNumber) {
    return (phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.nationalNumber[0]) === countryCode;
  }
  return false;
};
var trimPhoneNumber = function trimPhoneNumber(phoneNumber) {
  if (!phoneNumber) {
    return;
  }
  return phoneNumber.replace('+1', '').replace(/[\D]/g, '').trim().slice(0, 10);
};
exports.trimPhoneNumber = trimPhoneNumber;